import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	noticePeriod: null,
	error: "",
	loading: false,
};

// ADD_noticePeriod
export const addNoticePeriod = createAsyncThunk(
	"noticePeriod/addNoticePeriod",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `noticePeriod`,
				data: {
					...values,
				},
			});
			toast.success("Notice Period added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Notice Period try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_noticePeriod
export const deleteNoticePeriod = createAsyncThunk(
	"noticePeriod/deleteNoticePeriod ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `noticePeriod/${id}`,
			});

			toast.success("Notice Period deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Notice Period try again");
			console.log(error.message);
		}
	}
);


// noticePeriod
export const getAllNoticePeriod = createAsyncThunk(
	"noticePeriod/getAllNoticePeriod",
	async () => {
		try {
			const { data } = await axios.get(`noticePeriod`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateNoticePeriod = createAsyncThunk(
	"noticePeriod/updateNoticePeriod",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `noticePeriod/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Notice Period updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Notice Period try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const noticePeriodSlice = createSlice({
	name: "noticePeriod",
	initialState,
	reducers: {
		clearNoticePeriod: (state) => {
			state.noticePeriod = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllNoticePeriod ======

		builder.addCase(getAllNoticePeriod.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllNoticePeriod.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllNoticePeriod.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addNoticePeriod  ======

		builder.addCase(addNoticePeriod.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addNoticePeriod.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addNoticePeriod.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for updateNoticePeriod ======

		builder.addCase(updateNoticePeriod.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateNoticePeriod.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateNoticePeriod.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteNoticePeriod  ======

		builder.addCase(deleteNoticePeriod.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteNoticePeriod.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteNoticePeriod.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default noticePeriodSlice.reducer;
export const { clearNoticePeriod } = noticePeriodSlice.actions;
